module.exports = __webpack_public_path__ + "img/bondbreaker_game_button.40617bf0.jpg";